/** Align with backend product_unit_type: 'kg' / inventory UI 'weight' allows up to 3 decimal places; otherwise whole numbers only. */

export function normalizePurchaseQuantityInput(value, unitType) {
  const isKg = unitType === 'kg' || unitType === 'weight';
  const raw = String(value ?? '');
  if (isKg) {
    let s = raw.replace(/[^\d.]/g, '');
    let dot = s.indexOf('.');
    if (dot !== -1) {
      s = `${s.slice(0, dot + 1)}${s.slice(dot + 1).replace(/\./g, '')}`;
      dot = s.indexOf('.');
      const head = s.slice(0, dot + 1);
      const frac = s.slice(dot + 1, dot + 1 + 3);
      s = head + frac;
    }
    return s;
  }
  return raw.replace(/\D/g, '');
}

export function purchaseQuantityValidForUnit(qty, unitType) {
  if (!Number.isFinite(qty) || qty <= 0) return false;
  if (unitType === 'kg' || unitType === 'weight') {
    const quantized = Math.round(qty * 1000) / 1000;
    return Math.abs(qty - quantized) <= 1e-8;
  }
  return Math.abs(qty - Math.round(qty)) <= 1e-9;
}

/** Inventory stock: zero allowed; piece = whole numbers; kg / UI `weight` = up to 3 decimal places. */
export function inventoryStockQuantityValid(qty, unitType) {
  if (!Number.isFinite(qty) || qty < 0) return false;
  if (qty === 0) return true;
  const ut = unitType === 'kg' || unitType === 'weight' ? 'kg' : 'piece';
  return purchaseQuantityValidForUnit(qty, ut);
}

/** UI-only: round to 0.001 and show three fractional digits (e.g. stock preview under quantity). */
export function formatPurchaseStockPreviewDisplay(value) {
  const x = typeof value === 'number' ? value : parseFloat(value);
  if (!Number.isFinite(x)) return '0.000';
  return (Math.round(x * 1000) / 1000).toFixed(3);
}
